import React, { Fragment } from "react";

import { connect } from "react-redux";
import classes from "./Paggination.module.css";
import * as actionCreator from "../../../Store/actions/index";

const Paggination = (props) => {
  const pagginationElements = [];
  if (props.paggination.pagination_info) {
    const pageCount = props.paggination.pagination_info.pages_count;
    const pageNum = props.paggination.pagination_info.page;
    //
    let start = null,
      end = null;
    if (pageCount === "N/A") {
      start = 0;
      end = 0;
    } else if (+pageNum === 1) {
      start = +pageNum;
      end = start + 5;
    } else if (+pageNum === +pageCount) {
      if (+pageCount < 5) {
        start = +pageCount - 2;
      } else {
        start = +pageCount - 5;
      }
      end = +pageCount + 1;
    } else {
      start = +pageNum - 3;
      end = +pageNum + 4;
    }

    for (let count = start; count < end; count++) {
      //
      // for (let count = 1; count < pageCount + 1; count++) {
      const pageElement = (
        <Fragment key={count}>
          <input
            type="radio"
            value={count}
            checked={count === +pageNum ? true : false}
            name="page"
            id={`page${count}`}
            onChange={(event) => {
              // if (props.dealer) {
              //     props.onGetDealerPosts(props.dealer, event.target.value)
              // }
              // else if (props.fastType) {
              //     // props.onGetDealerPosts(props.dealer, event.target.value)
              //     props.onGetAllFastDeals(props.fastType, event.target.value);
              // }
              // else {
              //     props.onGetVehicleItems(props.vehicleType, event.target.value, props.brand, props.urlLink)
              // }
              props.onGetActivityPosts(
                props.model,
                props.mode,
                event.target.value
              );
            }}
          />
          <label htmlFor={`page${count}`} className={classes.PageNum}>
            {count <= 0 ? null : count > +pageCount ? null : count}
          </label>
        </Fragment>
      );
      pagginationElements.push(pageElement);
    }
  }
  let paggeinationClasses = classes.Paggination;
  if (props.loadingGetActPosts) {
    paggeinationClasses = `${classes.Paggination} ${classes.DiplayNone}`;
  }

  return <div className={paggeinationClasses}>{pagginationElements}</div>;
};

const mapStateToProps = (state) => {
  return {
    // vehicleType: state.SearchP.vehicleType,
    // itemsLoading: state.SearchP.itemsLoading,
    // urlLink: state.SearchP.currentURL
    loadingGetActPosts: state.Activity.loadingGetActPosts,
    activityPosts: state.Activity.activityPosts,
    activityError: state.Activity.activityError,
  };
};

const mapDispatchToprops = (dispatch) => {
  return {
    // onGetVehicleItems: (type, pageNum, brand, urlLink) => { dispatch(actionCreators.getVehicleItems(type, pageNum, brand, urlLink)) },
    onGetActivityPosts: (model, mode, page) => {
      dispatch(actionCreator.getActivityPosts(model, mode, false, page));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(Paggination);
